// extracted by mini-css-extract-plugin
module.exports = {"image":"dz","image-placeholder":"dA","imagePlaceholder":"dA"};